export abstract class DataInstance {
  protected id: number | undefined = undefined;

  abstract post(): void;
  abstract get currentData(): object;
  abstract get currentId(): number | undefined;
  // for now the return type is any, but really this is the class that extends DataInstance (should be static)
  // fromObject(o: object): any;
  // this will not force every inheriting class to implement the method, but it will throw an error at runtime, in case the function is used but not implemented.
  static fromObject(o: object): any {
    throw Error("fromObject method not implemented");
  }
}
